<template lang="pug">

  .add-playcard-button-component
    a(href="#", @click.prevent="showAddCardModal = true")
      slot {{ $t('cards.add_card') }}

    modal.add-playcard-modal(v-if="showAddCardModal", @close="showAddCardModal = false", container-class="wide")
      .v-modal-title {{ $t('add_playcard.title') }}
      form(@submit.prevent="addCard", @keydown="addCardForm.onKeydown($event)", :class="{ 'has-errors': addCardForm.errors.any() }")
        .v-modal-message.narrow.text-left
          .alert.alert-danger(v-if='addCardError') {{ addCardError }}
          form-group-row(:form="addCardForm", name="number", :label="$t('add_playcard.number')")
            input.form-control.playcard-control(v-model="addCardForm.number", type="text", name="number", :class="{'is-invalid': addCardForm.errors.has('number')}", :placeholder="$t('add_playcard.number_placeholder')" autocomplete="off")
            a.form-link.info(href="#", @click.prevent="showWhatsNumberModal = true") {{ $t('add_playcard.what_is_this') }}
          form-group-row(:form="addCardForm", name="cvv", :label="$t('add_playcard.cvv')")
            form-input.cvv-control(:form="addCardForm", name="cvv", type="password", :placeholder="$t('add_playcard.cvv_placeholder')"  autocomplete="off")
            a.form-link.info(href="#", @click.prevent="showWhatsCvvModal = true") {{ $t('add_playcard.what_is_this') }}
        .v-modal-buttons
          v-button.btn-primary(:loading="addCardForm.busy") {{ $t('add_playcard.submit') }}

    form-success-modal.add-playcard-success-modal(:form="addCardForm", @close="closeAddCardSuccessModal")
      template(slot="title") Success!
      template(slot="message") Your Swipe Card has been added.
      template(slot="buttons")
        button.btn.btn-primary(@click="closeAddCardSuccessModal") {{ $t('add_playcard.my_play_cards') }}

    modal.what-is-number-modal(v-if="showWhatsNumberModal", @close="showWhatsNumberModal = false")
      .card-number-help

    modal.what-is-cvv-modal(v-if="showWhatsCvvModal", @close="showWhatsCvvModal = false")
      .card-cvv-help

</template>

<script>
import Form from 'vform'

export default {
  name: 'add-playcard-button',

  props: {
    reloadOnAdd: Boolean
  },

  data: () => ({
    showAddCardModal: false,
    showWhatsNumberModal: false,
    showWhatsCvvModal: false,
    addCardForm: new Form({
      number: '',
      cvv: ''
    }),
    addCardError: null
  }),

  methods: {
    async addCard () {
      const {data} = await this.addCardForm.post(`${window.addiesaas.url}/api/playcards/playcard/add`);

      if (data && 'error' in data) {
        this.addCardForm.successful = false;
        this.addCardError = data.error;
      } else {
        this.showAddCardModal = false;
        if (!this.reloadOnAdd) {
          this.$emit('add');
        }
      }
    },

    closeAddCardSuccessModal() {
      if (this.reloadOnAdd) {
        window.location.reload(true)
      } else {
        this.addCardForm.successful = false
      }
    }
  }
}
</script>
